/**
 * Scripts for Independent Age Engaging Networks templates
 */

declare global {
  interface Window {
    EngagingNetworks: {
      validators: ENValidator[];
    };
    enVGSFields?: Record<string, { css: Record<string, string | Record<string, string>> }>;
    jQuery?: (selector: string) => {
      animate: (properties: Record<string, number>, duration: number) => void;
    };
    onENValidateSetupCompleteArray: Array<() => void>;
    pageJson: { campaignId: number; locale: string; pageType: ENActionType };
  }
}

import { accordions } from './scripts/accordion';
import { backgroundImage } from './scripts/background';
import { mpThumbnails } from './scripts/email-to-target';
import { mobileSkipToFormButton, sideBySideElements, vgsCardFieldStyles } from './scripts/forms';
import { mobileShareButton } from './scripts/share';
import { ENActionType } from './scripts/types/en-action-type';
import { ENValidator } from './scripts/types/en-validator';
import {
  shortenLongValidationMessages,
  stripHtmlFromValidationMessages,
} from './scripts/validation';

// Import styles so they are included in the build
import './styles/main.scss';

// Run immediately - function checks whether page has loaded and if not, it will run again until it finds the background image settings or page finishes loading
backgroundImage();

// Run immediately - functional code will actually run when ENvalidate setup is complete
stripHtmlFromValidationMessages();
shortenLongValidationMessages();

// Functions that run on page load
document.addEventListener('DOMContentLoaded', () => {
  accordions();
  mobileShareButton();
  mobileSkipToFormButton();
  mpThumbnails();
  sideBySideElements();
  vgsCardFieldStyles();
});
